/**
 * Pure pricing/IVA helpers — no React, no state, safe to import anywhere.
 */

export const formatPrice = (price) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(price);

export const formatPriceWithIva = (price, ivaPercentage) => {
  const ivaRate = parseFloat(ivaPercentage) / 100;
  return formatPrice(price * (1 + ivaRate));
};

/**
 * Return the first active promotion applicable to `articleId`, or null.
 * A promo applies when `applicable_articles` is empty (catch-all) or contains the id.
 */
export const findArticleDiscount = (activePromotions, articleId) => {
  for (const promo of activePromotions || []) {
    if (!(Number(promo.discount_value) > 0) || !["percentage", "fixed"].includes(promo.discount_type)) continue;
    const applicable = promo.applicable_articles || [];
    if (applicable.length === 0 || applicable.includes(articleId)) {
      return promo;
    }
  }
  return null;
};

/**
 * Compute the post-discount price (IVA already applied).
 */
export const getDiscountedPrice = (price, ivaPercentage, discount) => {
  const priceWithIva = price * (1 + (ivaPercentage || 0) / 100);
  if (discount.discount_type === "percentage") {
    return priceWithIva * (1 - discount.discount_value / 100);
  }
  return Math.max(0, priceWithIva - discount.discount_value);
};
